import { useEffect } from 'react';
import { ControlsPanel } from '../components/left/ControlsPanel';
import { CreationCanvas } from '../components/center/CreationCanvas';
import { ChatPanel } from '../components/right/ChatPanel';
import { CanvasProvider } from '../lib/canvasStore';

export function Home() {
  // Mark body for no-scroll behaviour on home only
  useEffect(() => {
    document.body.dataset.route = '/';
    return () => {
      document.body.dataset.route = '';
    };
  }, []);

  return (
    <CanvasProvider>
    <div className="m-shell" id="home-shell">
      <div className="m-grid" role="main">
        <section className="m-col" id="col-left" aria-label="Panneau de contrôle">
          <div className="m-col__head">
            <span>controls</span>
            <span style={{ color: 'var(--fg-faint)' }}>L</span>
          </div>
          <div className="m-col__body">
            <ControlsPanel />
          </div>
        </section>

        <section className="m-col" id="col-center" aria-label="Canevas de création">
          <div className="m-col__head">
            <span>canvas</span>
            <span style={{ color: 'var(--fg-faint)' }}>C</span>
          </div>
          <div className="m-col__body" style={{ padding: 0 }}>
            <CreationCanvas />
          </div>
        </section>

        <section className="m-col" id="col-right" aria-label="Chat live">
          <div className="m-col__head">
            <span>chat</span>
            <span style={{ color: 'var(--fg-faint)' }}>R</span>
          </div>
          <div className="m-col__body">
            <ChatPanel />
          </div>
        </section>
      </div>

    </div>
    </CanvasProvider>
  );
}
